import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyAdminPassword } from '../api/admin';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/type';

const AdminMiddleware = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const user = useSelector((state: RootState) => state.userData);

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const isValid = user?.role === 'admin';
        setIsAuthorized(isValid);

        if (!isValid) {
          navigate('/restricted'); // Redirect if verification fails
        }
      } catch (error) {
        console.error('Admin verification failed:', error);
        navigate('/restricted');
      }
    };

    checkAuthorization();
  }, [navigate]);

  // Prevent rendering until authorization check is complete
  if (isAuthorized === null) return null;

  return <>{children}</>;
};

export default AdminMiddleware;
